import React, { useContext, useState } from 'react';
import PollTab from '../postTabs/PollTab';
import PostTab from '../postTabs/PostTab';
import WebinarTab from '../postTabs/WebinarTab';
import { Modal, ModalBody } from 'reactstrap';
import ClinicalSessionTab from '../postTabs/ClinicalSessionTab';
import ClinicalStudyTab from '../postTabs/ClinicalStudyTab';
import { Language } from '../../../App';
import { TypeTab } from './PostForm';
import { IoClose } from 'react-icons/io5';
import '../postTabs/formTheme.css';

function CreatePostPopup({
  selectedLabel,
  refetch,
  selectedPost,
  editWebinar,
  setEditWebinar,
  show,
  onHide,
  handleApiCall,
  setProgress,
  handlePostSelect,
}) {
  const { lang } = useContext(Language);
  const [activeTab, setActiveTab] = useState(editWebinar ? lang?.webinar : selectedLabel);

  const commonProps = {
    onHide,
    setProgress,
    handleApiCall,
    refetch,
  };

  const tabs = [
    {
      id: navigator.language.startsWith("en") ? 'Publish' : "Publicar",
      typeKey: "publish",
      title: lang?.publish || "Post",
      component: <PostTab {...commonProps} />,
    },
    {
      id: lang?.poll || "Poll",
      typeKey: "poll",
      title: lang?.poll || "Poll",
      component: <PollTab {...commonProps} />,
    },
    {
      id: lang?.webinar || "Webinar",
      typeKey: "webinar",
      title: lang?.webinar || "Webinar",
      component: (
        <WebinarTab
          setEditWebinar={setEditWebinar}
          refetch={refetch}
          selectedPost={selectedPost}
          editWebinar={editWebinar}
          handlePostSelect={handlePostSelect}
          {...commonProps}
        />
      ),
    },
    {
      id: lang?.clinical_study || "Clinical Study",
      typeKey: "study",
      title: lang?.clinical_study || "Clinical Study",
      component: <ClinicalStudyTab {...commonProps} />,
    },
    {
      id: lang?.clinical_session || "Clinical Session",
      typeKey: "session",
      title: lang?.clinical_session || "Clinical Session",
      component: <ClinicalSessionTab {...commonProps} />,
    },
  ];

  const activeTypeKey = tabs.find((t) => t.id === activeTab)?.typeKey || "publish";

  const handleModalClose = () => {
    onHide();
    if (setEditWebinar) {
      setEditWebinar(false);
    }
  };

  return (
    <Modal
      className="modal-lg pf-modal"
      isOpen={show}
      toggle={handleModalClose}
      centered
      backdrop="static"
    >
      {!editWebinar && (
        <div className="pf-modal-header-wrapper">
          <div className="pf-modal-tabs">
            {tabs.map(({ id, typeKey, title }) => (
              <TypeTab
                key={id}
                label={title}
                typeKey={typeKey}
                isActive={activeTab === id}
                onClick={() => setActiveTab(id)}
              />
            ))}
          </div>
          <button
            type="button"
            className="pf-modal-close-btn"
            onClick={handleModalClose}
            aria-label="Close"
          >
            <IoClose size={18} />
          </button>
        </div>
      )}

      <ModalBody className={`pf-modal-body pf-scope-${activeTypeKey}`}>
        {/* Render the active tab component with smooth transition */}
        <div key={activeTab} className="pf-tab-pane-transition">
          {tabs.find(({ id }) => activeTab === id)?.component}
        </div>
      </ModalBody>
    </Modal>
  );
}

export default CreatePostPopup;
